<button type="button" [disabled]="valid" mat-raised-button class="me-2 w-100" [class]="theme.myButtonBgColor" (click)="onClick()">
    <mat-icon>save</mat-icon>  Submit
</button>

